export const offerfitAppGroupIdUseCasesUseCaseIdCampaignData =
  "/offerfit/:app_group_id/use_cases/:use_case_id/campaign_data";
